export default function meta({ to, next, store }) {
  const loginQuery = { name: "Login", query: { redirect: to.fullPath } };

  if (!store.getters.isMetaLoaded) {
    store
      .dispatch("fetchMeta")
      .then(() => {
        if (!store.getters.isMetaLoaded) {
          next(loginQuery);
        } else {
          next();
        }
      })
      .catch(() => {});
  } else {
    next();
  }
}
